import { useState } from "react";
import { Img, DemoAction, Chip } from "./shared";

const CLASSES = [
  { d: "Mo", t: "06:30", n: "Strength Basics", c: "Kraft" }, { d: "Mo", t: "18:00", n: "Engine HIIT", c: "Ausdauer" },
  { d: "Di", t: "07:00", n: "Mobility Flow", c: "Mobilität" }, { d: "Di", t: "19:00", n: "Barbell Club", c: "Kraft" },
  { d: "Mi", t: "12:15", n: "Lunch Burn", c: "Ausdauer" }, { d: "Do", t: "18:30", n: "Olympic Lifting", c: "Kraft" },
  { d: "Fr", t: "07:00", n: "Stretch & Breathe", c: "Mobilität" }, { d: "Sa", t: "10:00", n: "Team WOD", c: "Ausdauer" },
];

export default function Fitness({ wide, onCta }) {
  const [c, setC] = useState("Alle");
  const list = CLASSES.filter((x) => c === "Alle" || x.c === c);
  return (
    <div className="bg-[#0A0A0A] text-white" style={{ fontFamily: "'Archivo Variable', sans-serif" }}>
      <section className={`relative overflow-hidden ${wide ? "h-[540px]" : "h-[500px]"}`}>
        <Img k="fit1" alt="Training mit Langhantel" className="opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] to-transparent" />
        <header className="absolute inset-x-0 top-0 flex justify-between px-5 pt-12 text-[13px] font-bold" style={wide ? { paddingTop: 24, paddingLeft: 48, paddingRight: 48 } : undefined}>
          <span style={{ fontFamily: "Anton, sans-serif" }} className="text-[20px] tracking-wide">FORGE<span className="text-[#C6FF00]">/</span>ATHLETICS</span>
        </header>
        <div className={`absolute bottom-0 ${wide ? "left-12 pb-12" : "left-5 right-5 pb-8"}`}>
          <h1 className={`uppercase leading-[0.86] ${wide ? "text-[120px]" : "text-[76px]"}`} style={{ fontFamily: "Anton, sans-serif" }}>
            Stärker<br /><span className="text-[#C6FF00]">als gestern.</span>
          </h1>
        </div>
      </section>
      <section className={wide ? "px-12 py-14" : "px-5 py-10"}>
        <div className="flex items-end justify-between">
          <h2 className="text-[34px] uppercase leading-none" style={{ fontFamily: "Anton, sans-serif" }}>Kursplan</h2>
          <span className="text-[11px] uppercase tracking-widest text-white/60">Beispielwoche</span>
        </div>
        <div className="no-scrollbar mt-4 flex gap-2 overflow-x-auto">
          {["Alle", "Kraft", "Ausdauer", "Mobilität"].map((x) => (
            <Chip key={x} active={c === x} onClick={() => setC(x)} activeCls="bg-[#C6FF00] text-black" idleCls="bg-white/10 text-white" className="-skew-x-6 px-4 py-2 text-[13px] font-bold uppercase">{x}</Chip>
          ))}
        </div>
        <ul className={`mt-5 grid gap-2 ${wide ? "grid-cols-2" : ""}`}>
          {list.map((x) => (
            <li key={x.n} className="flex items-center gap-4 border-l-4 border-[#C6FF00] bg-white/5 px-4 py-3">
              <span className="w-8 text-[13px] font-bold text-white/60">{x.d}</span>
              <span className="w-12 text-[15px] font-bold">{x.t}</span>
              <span className="flex-1 text-[15px]">{x.n}</span>
              <span className="text-[11px] uppercase text-[#C6FF00]">{x.c}</span>
            </li>
          ))}
        </ul>
        <DemoAction label="Probetraining sichern" onCta={onCta} className="mt-6 w-full bg-[#C6FF00] py-4 text-[15px] font-black uppercase text-black" />
      </section>
    </div>
  );
}
